// extracted by mini-css-extract-plugin
export default {"container":"YoutubePlayer_container__AVSYd","frame":"YoutubePlayer_frame__PYLvj"};